import UtilInstance from'@byted/fe-utilx';// https://web-**************/package/@byted/fe-utilx
var hybrid=new UtilInstance({defaultLanguage:'en'});export{hybrid};